export default "/fonts/Ubuntu-Bold.woff2?6d67deb822219b40151c6c763ac13f4d";